import React from 'react';
import './SearchFilter.css';

const SearchFilter = ({ searchTerm, onSearchChange, roleFilter, onRoleChange, statusFilter, onStatusChange }) => {
  return (
    <div className="search-filter-bar">
      <div className="search-box">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="搜尋帳號、姓名或 Email..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <select className="filter-select" value={roleFilter} onChange={(e) => onRoleChange(e.target.value)}>
        <option value="">所有角色</option>
        <option value="manager">主管</option>
        <option value="purchasing">採購</option>
        <option value="sales">業務</option>
      </select>
      <select className="filter-select" value={statusFilter} onChange={(e) => onStatusChange(e.target.value)}>
        <option value="">所有狀態</option>
        <option value="true">啟用</option>
        <option value="false">停用</option>
      </select>
    </div>
  );
};

export default SearchFilter;
